'use strict';

(function () {
  'use strict';
  /**
   * A service to send events to Google analytics.
   */

  angular.module('msCore').service('eventTrackingSvc', EventTrackingSvc);

  EventTrackingSvc.$inject = ['$window', '$state', '$location', '$log', 'AuditSvc', 'msAuth', 'userSvc', 'msGa', '$rootScope'];

  function EventTrackingSvc($window, $state, $location, $log, AuditSvc, msAuth, userSvc, msGa, $rootScope) {

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/custom-dims-mets#sending_data
    var customDimensions = {
      dimension1: 'organization - orgType - accessCode - codeType',
      dimension2: 'sessionId'
    };

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#pageview_fields
    var pageviewData = {
      hitType: 'pageview',
      title: '',
      location: '',
      page: ''
    };

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/events#event_fields
    var eventData = {
      hitType: 'event',
      eventCategory: '',
      eventAction: '',
      eventLabel: '',
      eventValue: 0
    };

    return {
      init: initializeGA,
      registerEventListeners: registerEventListeners,
      pageview: pageview,
      fireEvent: fireEvent,
      browserHasDoNotTrack: browserHasDoNotTrack,
      sendLinkClickEventAndNavigate: sendLinkClickEventAndNavigate
    };

    function _getBaseUrl() {
      // get the base URL for pageviews
      var base = document.getElementsByTagName('base')[0];
      if (base && base.hasAttribute('href')) {
        base = base.getAttribute('href');
        if (base.slice(-1) === '/') {
          base = base.substr(0, base.length - 1);
        }
      }
      return base;
    }

    function _isValidTrackingCode(str) {
      // https://gist.github.com/faisalman/924970
      if (str) {
        return (/^ua-\d{4,9}-\d{1,4}$/i.test(str.toString())
        );
      }
      return false;
    }

    //////////////////

    function initializeGA() {
      var trackingCode = _.get($window, 'MYSTRENGTH.config.platforms.web.googleAnalyticsTrackingCode');
      // Fallback to Develop Tracking Code if the real one isn't available.
      if (!_isValidTrackingCode(trackingCode)) {
        trackingCode = 'UA-23695477-9';
        $log.debug('GA Tracking Code not available. Falling back to Development Tracking Code.');
      } else {
        $log.debug('GA Custom Events Initialized.');
      }
      // 'auto' for automatic cookie detection.
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#automatic_cookie_domain_configuration
      msGa('create', trackingCode, 'auto');
      msGa('set', 'anonymizeIp', true);
      // add the org - accessCode to this session if possible
      if (msAuth.isLoggedIn()) {
        var sessionId = msAuth.getSessionId();
        userSvc.getUser().then(function (user) {
          customDimensions.dimension2 = sessionId;
          msGa('set', 'dimension2', customDimensions.dimension2);
          if (user && user.hasOwnProperty('account_type')) {
            customDimensions.dimension1 = user.account_type === 'TEST' ? 'TEST_USER' : user.organization.shortName + ' - ' + user.organization.type + ' - ' + user.accessCode.accessCode + ' - ' + user.accessCode.type;
          }
          msGa('set', 'dimension1', customDimensions.dimension1);
        });
      }
    }

    function registerEventListeners() {
      $rootScope.$on('$stateChangeSuccess', pageview);
      $log.debug('GA Virtual Page Views Registered.');
    }

    function pageview() {
      pageviewData.title = $state.current.name;
      pageviewData.location = $location.absUrl();
      pageviewData.page = _getBaseUrl() + $location.path();

      msGa('send', pageviewData);
    }

    // The first 4 arguments that are Strings or Numbers will be considered GA Data.
    // If the last argument is an object, it will be sent to our DB via AuditSvc (along with the GA data).
    function fireEvent() {
      var auditInfo = void 0,
          eventAudit = void 0,
          additionalData = void 0;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var stringArgs = args.filter(function (arg) {
        return _.isString(arg) || _.isNumber(arg);
      });

      eventData.eventCategory = stringArgs[0];
      eventData.eventAction = stringArgs[1];
      eventData.eventLabel = stringArgs[2];
      eventData.eventValue = stringArgs[3];

      // If the last argument is an object, save it.
      if (_.isObject(args[args.length - 1])) {
        additionalData = args[args.length - 1];
      }

      // merge additional data with GA Event data
      auditInfo = _.merge(additionalData, eventData);

      // omit all properties that are null or undefined
      eventAudit = {
        auditProperties: _.omitBy(auditInfo, _.isNil),
        auditType: 'CUSTOM_EVENT'
      };

      // Send event to our server, and to GA
      AuditSvc.generateAuditEvent(eventAudit);
      msGa('send', 'event', eventData);
    }

    function browserHasDoNotTrack() {
      var navigator = $window.navigator;
      if ($window.doNotTrack || navigator.doNotTrack || navigator.msDoNotTrack || $window.external && 'msTrackingProtectionEnabled' in $window.external) {
        // Browser supports Do Not Track
        if ($window.doNotTrack === '1' || $window.doNotTrack === 1 || navigator.doNotTrack === 'yes' || navigator.doNotTrack === 'unspecified' || navigator.doNotTrack === '1' || navigator.doNotTrack === 1 || navigator.msDoNotTrack === '1' || navigator.msDoNotTrack === 1 || $window.external && $window.external.msTrackingProtectionEnabled()) {
          // Do Not Track enabled
          return true;
        }
      }

      // Do Not Track disabled or not supported by browser
      return false;
    }

    /**
     * Record event to google analytics then navigate to location
     * Used in member messaging links
     *
     * @param { Event } $event The angular provided click event
     * @param { String } navigationUrl The url to navigate to after sending analytic event
     * @param { category, action, value } eventData The event data to be sent to google analytics
     */
    function sendLinkClickEventAndNavigate($event, navigationUrl, eventData) {
      if (!browserHasDoNotTrack()) {
        $event.preventDefault();
      }

      $window.ga('send', 'event', eventData.category, eventData.action, eventData.value, {
        hitCallback: function hitCallback() {
          $window.location.replace(navigationUrl);
        }
      });
    }
  }
})();